export default __webpack_public_path__ + "static/media/C++.604fcb2c.svg";